/*
 * @Author: Dom
 * @Date: 2022-07-28 14:16:44
 * @LastEditTime: 2022-07-28 16:06:47
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\userstatus.ts
 */
import request from '@/utils/request';
import {UserInfoParams} from './data.d'

export async function checkUserStatus(params:UserInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/order/checkUserStatus',
        method: 'get',
        params
    });
}

export async function checkAccountStatus(params:UserInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/accountRechargeFlow/checkAccountStatus',
        method: 'get',
        params
    });
}
